import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/customers': {
                params: { filter: 'registered:1' }
            },
            '^/customer_projects': {
                params: { sort: 'updated_at:desc' }
            },
            '^/span_calculations': {
                params: { sort: 'updated_at:desc' }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
            rvt: ['rvt'],
            rfa: ['rfa'],
            zip: ['zip'],
            bin: ['bin'],
        }
    },
    menu,
    notifications,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/base.js